<template>
  <div class="nut-cta d-inline-block button-filter text-right w-100 mt-3 mb-3">
    <base-button class="float-right" button="Đóng" @click="onClose" />
    <base-button
      v-if="!isView"
      color="btn-warning"
      class="float-right"
      button="Làm mới"
      @click="onReset"
    />
    <base-button
      v-if="isView"
      :disabled="disabled"
      class="float-right"
      button="Cập nhật"
      @click="onUpdate"
    />
    <base-button
      v-if="!isView"
      :disabled="disabled"
      icon="plus-circle-fill"
      color="btn-success"
      class="float-right"
      button="Lưu"
      @click="onLuu"
    />
  </div>
</template>

<script>
import { ROUTE_NAME } from "@/constants/constants";
export default {
  name: "ButtonFilter",
  data() {
    return {
      ROUTE: ROUTE_NAME,
    };
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    isView: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onLuu() {
      this.$emit("onLuu");
    },
    onClose() {
      if (
        this.$router.currentRoute.name ===
          this.ROUTE.QUAN_TRI_HE_THONG.CAP_NHAT_THONG_TIN_NGUOI_DUNG ||
        this.$router.currentRoute.name ===
          this.ROUTE.QUAN_TRI_HE_THONG.XEM_CHI_TIET_THONG_TIN_NGUOI_DUNG
      ) {
        this.$router.push(
          `${this.ROUTE.QUAN_TRI_HE_THONG.NAME}${
            this.ROUTE.QUAN_TRI_HE_THONG.QUAN_LY_THONG_TIN_NGUOI_DUNG
          }`
        );
      } else {
        this.$router.push(
          `${this.ROUTE.QUAN_LY_DANH_MUC.NAME}${
            this.ROUTE.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.NAME
          }`
        );
      }
    },
    onReset() {
      this.$emit("onReset");
    },
    onUpdate() {
      if (
        this.$router.currentRoute.name ===
          this.ROUTE.QUAN_TRI_HE_THONG.CAP_NHAT_THONG_TIN_NGUOI_DUNG ||
        this.$router.currentRoute.name ===
          this.ROUTE.QUAN_TRI_HE_THONG.XEM_CHI_TIET_THONG_TIN_NGUOI_DUNG
      ) {
        window.location.href = `${this.ROUTE.QUAN_TRI_HE_THONG.NAME}${
          this.ROUTE.QUAN_TRI_HE_THONG.QUAN_LY_THONG_TIN_NGUOI_DUNG
        }/${this.$route.params.id}/cap-nhat`;
      } else {
        window.location.href = `${this.ROUTE.QUAN_LY_DANH_MUC.NAME}${
          this.ROUTE.QUAN_LY_DANH_MUC.HO_SO_CAN_BO.NAME
        }/${this.$route.params.id}/cap-nhat`;
      }
    },
  },
};
</script>
